import { State } from "../../../app/store/types";

export const selectInstallationModalDisplayedOnFirstVisit = (
  state: State
): boolean => state.installationModalDisplayedOnFirstVisit;

export const selectShowModal = (state: State): boolean =>
  state.installationModal.showModal;
